import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import {
    createStyles,
    Button,
    Collapse,
    Textarea,
    FileInput,
    Text,
    Image,
    FileButton
} from '@mantine/core';
import { Dropzone, MIME_TYPES, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import {
    DateRangePicker,
    TimeInput
} from '@mantine/dates';

import { ResponsiveCarouselCardB } from '../components/ResponsiveCarouselCardB';

import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';


const useStyles = createStyles((theme) => ({
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    }
    
}));


//descript:render image upload sections for listing
export function CarCreationCardBComp(
    {
        placeHolder,
        itemLabel,
        itemName,
        galleryName
    }
    ) {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const component_md = {
        par: 'auctions',
        child: 'carCreatorData',
        section: 'articleSection_6',
    }
    const parSection = 'carCreatorData';
    const activeSection = 'articleSection';
    
    const n_Gallery = useSelector(selectSectionData(
        {
            par: component_md['par'],
            child: component_md['child'],
            section: component_md['section'],
            item: galleryName
        }
    ))
    const n_Descript = useSelector(selectSectionData(
        {
            par: component_md['par'],
            child: component_md['child'],
            section: component_md['section'],
            item: itemName
        }
    ))
    const [descript, setDescript] = useState(n_Descript);
    const onDescriptChanged = (e) => {
        setDescript(e.target.value);
        dispatch(fieldInfoUpdated(
            {
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: itemName,
                itemVal: e.target.value,
            }
        ))
    }
    const handleGalleryDrop = (e) => {
        let iGallery = [];
        for (let i = 0; i < e.length; i++){
            let imageHold = {
                src: URL.createObjectURL(e[i]),
                width: 1,
                height: 1,
                mime: e[i].type,
                origName: e[i].path
            };
            iGallery.push(imageHold)
        }
        dispatch(fieldInfoUpdated(
            {
                
                par: component_md['par'],
                child: component_md['child'],
                section: component_md['section'],
                item: galleryName,
                itemVal: iGallery,
            }
        ));
    }
    
    const [galleryPreview, setGalleryPreviewOpen] = useState(false);
    const onGalleryPreviewOpen = (e) => setGalleryPreviewOpen((o) => !o);
    /*
     * 
     * accept={IMAGE_MIME_TYPE}
     * */
    
    return (
        <>
            <Textarea
                placeholder={placeHolder}
                label={itemLabel}
                autosize
                minRows={2}
                maxRows={5}
                value={descript}
                onChange={onDescriptChanged}
            />
            <Dropzone
                multiple={false}
                accept="*"
                onDrop={handleGalleryDrop}
            >
                <Text align="center">Click or Drop Image Here</Text>
            </Dropzone>
            <br/>
            {n_Gallery.length > 0 &&
                <>
                    <Button onClick={onGalleryPreviewOpen}>
                        Preview Gallery
                    </Button>
                    <Collapse in={galleryPreview} transitionDuration={1000} transitionTimingFunction="linear">
                        <ResponsiveCarouselCardB incImages={n_Gallery}/>
                    </Collapse>
                </>
            }
            <br/>
        </>
    );
}
